import { LoadableLazy } from '@confluence/loadable';

import type { RestrictionsDialogProps } from '../types.ts';

export const RestrictionsDialogLoader = LoadableLazy<RestrictionsDialogProps>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictionsDialog" */ './RestrictionsDialog.tsx'))
			.RestrictionsDialog,
});
